import { render, staticRenderFns } from "./PodtEditBomChild.vue?vue&type=template&id=4bebf064&scoped=true&"
import script from "./PodtEditBomChild.vue?vue&type=script&lang=js&"
export * from "./PodtEditBomChild.vue?vue&type=script&lang=js&"
import style0 from "./PodtEditBomChild.vue?vue&type=style&index=0&id=4bebf064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebf064",
  null
  
)

export default component.exports